import { useCallback } from 'react';
import { FrStatuses } from '@libs/graphql';
export const useEnabledFeatures = (enabledFeatures, loading, user, userLoading) => {
    const checkFeature = useCallback((feature) => {
        const matchedFeature = enabledFeatures?.find((enabledFeature) => enabledFeature.feature === feature);
        return {
            isAvailable: !!matchedFeature,
            isLoading: !!loading || !!userLoading,
            isKycRequired: !!matchedFeature?.kycRequired &&
                user?.frStatus !== FrStatuses.VERIFIED,
        };
    }, [loading, enabledFeatures, userLoading, user]);
    const checkMultipleFeatures = useCallback((features) => {
        const matchedFeature = enabledFeatures?.find((enabledFeature) => features.includes(enabledFeature.feature));
        return { isAvailable: !!matchedFeature, isLoading: !!loading };
    }, [loading, enabledFeatures]);
    return {
        enabledFeatures: enabledFeatures,
        checkFeature,
        checkMultipleFeatures,
        isLoading: loading || userLoading,
    };
};
//# sourceMappingURL=useEnabledFeatures.js.map